import {Avatar, Card, CardActionArea, CardHeader, Divider, Grid, Typography, useTheme} from "@mui/material";
import SvgIconTelegram from "../util/SvgIconTelegram";
import SvgIconVK from "../util/SvgIconVK";
import SvgIconTikTok from "../util/SvgIconTikTok";
import SvgIconYouTube from "../util/SvgIconYouTube";
import SvgIconX from "../util/SvgIconX";
import SvgIconBluesky from "../util/SvgIconBluesky";
import React from "react";
import {useLocale} from "../locale/Locale";
import SvgIconThreads from "../util/SvgIconThreads";
import SvgIconRUTUBE from "../util/SvgIconRUTUBE";
import SvgIconDzen from "../util/SvgIconDzen";
import SvgIconPlayground from "../util/SvgIconPlayground";
import SvgIconTwitch from "../util/SvgIconTwitch";
import SvgIconDTF from "../util/SvgIconDTF";

function AppSocial() {

    const {localeText} = useLocale()
    
    const xs = 12
    const sm = 6
    const md = 3
    
    return (
        <>
            <Typography variant="h2" align="center">{localeText('socialNetworksTitle')}</Typography>
            <Typography align="center" mb={2}>{localeText('socialNetworksDescription')}</Typography>
            <Grid container spacing={2}>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://t.me/isaev_inc"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconTelegram/>
                                    </Avatar>
                                }
                                title="Telegram"
                                subheader="@isaev_inc"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://vk.com/isaev_inc"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconVK/>
                                    </Avatar>
                                }
                                title="VK"
                                subheader="@isaev_inc"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://tiktok.com/@isaev_inc"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconTikTok sx={{color: useTheme().palette.text.primary}}/>
                                    </Avatar>
                                }
                                title="TikTok"
                                subheader="@isaev_inc"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://youtube.com/@isaev_inc"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconYouTube/>
                                    </Avatar>
                                }
                                title="YouTube"
                                subheader="@isaev_inc"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://rutube.ru/channel/38382219"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconRUTUBE/>
                                    </Avatar>
                                }
                                title="RUTUBE"
                                subheader="channel/38382219"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            // почему-то AdBlock скрывает контент, если указана ссылка на Дзен
                            // href="https://dzen.ru/isaevspace"
                            href="https://vk.cc/cU6Q0Y"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconDzen/>
                                    </Avatar>
                                }
                                title={localeText('dzen')}
                                subheader="@isaevspace"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://users.playground.ru/1256791"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconPlayground/>
                                    </Avatar>
                                }
                                title="PlayGround"
                                subheader="1256791"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://dtf.ru/u/1440702-isaev-space"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconDTF sx={{color: useTheme().palette.text.primary}}/>
                                    </Avatar>
                                }
                                title="DTF"
                                subheader="u/1440702-isaev-space"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://www.twitch.tv/nanaki_xx"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconTwitch/>
                                    </Avatar>
                                }
                                title="Twitch"
                                subheader="nanaki_xx"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://x.com/ISAEV_SPACE"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconX sx={{color: useTheme().palette.text.primary}}/>
                                    </Avatar>
                                }
                                title="X"
                                subheader="@ISAEV_SPACE"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://bsky.app/profile/isaevspace.bsky.social"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconBluesky/>
                                    </Avatar>
                                }
                                title="Bluesky"
                                subheader="@isaevspace.bsky.social"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://www.threads.com/@__nanaki__"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconThreads sx={{color: useTheme().palette.text.primary}}/>
                                    </Avatar>
                                }
                                title="Threads"
                                subheader="@__nanaki__"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
            </Grid>
            <Divider sx={{my: 4}}/>
        </>
    )

}

export default AppSocial
